import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import sage from "../../../images/splash/sage.jpeg";
import Nav from 'react-bootstrap/Nav';
import {Navbar,NavDropdown} from 'react-bootstrap';
import { Card, Form, Button, Table } from 'react-bootstrap';
import pro from "../../../images/splash/prof.png";
import axios from "axios";
import { var_api } from "../../constant";
import Modal from 'react-bootstrap/Modal';
import Loader from "../Loader";
import Pagination from 'react-js-pagination';
import React, { useState, useEffect,useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import { Step } from '@material-ui/core';

const PackageMaster = () => {
  const [editMode, setEditMode] = useState(false);
  const [isLogin, setIsLogin] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; 
  const [startIndex, setStartIndex] = useState(0);
  const [ searchQuery,setSearchQuery] = useState('');
  const history = useHistory();
  const [packageList, setPackageList] = useState([]);
  const [packageid, setpackageid] = useState('');
  const [packageName, setPackageName] = useState('');
  const [discount, setDiscount] = useState('');
  const [description, setDescription] = useState('');
  const [price, setPrice] = useState('');
  const [is_discount, setIsDiscount] = useState(1);
  const [is_active, setIsactive] = useState(1);
  const [totalAmount, settotalAmount] = useState('');
  const [finalAmount, setFinalAmount] = useState('');
  const [serviceCount, setServiceCount] = useState('');
  const [errors, setErrors] = useState({});


  useEffect(() => {
    fetchpackageMaster();
}, [currentPage]);

const fetchpackageMaster = async () => {
  const token = localStorage.getItem('token');
  setIsLogin(true);
  try {
      const response = await axios.get(`${var_api}/api/package-combo/get`, {
          headers: {
              'Authorization': `${token}`
          }
      });
      setPackageList(response.data);
      
      setIsLogin(false);
  } catch (error) {
    setPackageList([]);
      if (error.response && error.response.status === 401) {
        history.push('/signin');
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error.response?.data?.error || 'Something went wrong!',
          confirmButtonColor: '#007500',
        });
      }
  }
};


const validateForm = () => {
  const newErrors = {};

  if (!packageName) newErrors.title = 'Package Name is required';
  if (!discount && !price) newErrors.value = 'Value is required';
  if (!description) newErrors.description = 'Description is required';

  return newErrors;
};


const createPackageMaster = async () => {
    const newErrors = validateForm();
    setErrors(newErrors); // Update the state with validation errors
  
    // If there are errors, don't proceed with the form submission
    if (Object.keys(newErrors).length > 0) {
      return;
    }
  
    const token = localStorage.getItem('token');
    setIsLogin(true);
  
    // Create a JSON object instead of FormData
    const payload = {
        package_name: packageName,
        description: description,
        discount: parseInt(discount) || 0,
        price: parseInt(price) || 0,
        services_count: 0,
        total_amount: 0,
        final_amount: 0,
        is_discount: is_discount,
        is_active: 1,
    };
  
    try {
      const response = await axios.post(`${var_api}/api/package-combo/post`, payload, {
        headers: {
          'Authorization': `${token}`,
          'Content-Type': 'application/json'
        }
      });
  
      if (response.status === 200) {
        Swal.fire({
          icon: 'success',
          text: 'Package Created Successfully',
          confirmButtonColor: '#007500',
        });
        console.log('Package created successfully!');
      }
      fetchpackageMaster();
      resetForm();
    } catch (error) {
      console.error('Error:', error);
      if (error.response && error.response.status === 401) {
        history.push('/signin');
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error.response?.data?.error || 'Something went wrong!',
          confirmButtonColor: '#007500',
        });
      }
    } finally {
      setIsLogin(false);
    }
  };
  

  const updatePackage = async () => {
    const token = localStorage.getItem('token');
    setIsLogin(true);
    
    const newErrors = validateForm();
    setErrors(newErrors); // Update the state with validation errors
  
    // If there are errors, don't proceed with the form submission
    if (Object.keys(newErrors).length > 0) {
      return;
    }
  
    // Create a JSON object instead of FormData
    const payload = {
      package_name: packageName,
      description: description,
      is_discount:  is_discount,
      discount: is_discount === 1 ? parseInt(discount) : 0,
      price: is_discount === 1 ? 0 : parseInt(price), 
      services_count: serviceCount,
      total_amount: totalAmount,
      final_amount: finalAmount,
      is_active: is_active
    };
  
    try {
      const response = await axios.put(`${var_api}/api/package-combo/put/${packageid}`, payload, {
        headers: {
          'Authorization': `${token}`,
          'Content-Type': 'application/json'
        }
      });
  
      if (response.status === 200) {
        Swal.fire({
          icon: 'success',
          text: 'Package Updated Successfully',
          confirmButtonColor: '#007500',
        });
        console.log('Package updated successfully!');
      }
      fetchpackageMaster();
      resetForm();
    } catch (error) {
      console.error('Error:', error);
      if (error.response && error.response.status === 401) {
        history.push('/signin');
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error.response?.data?.error || 'Something went wrong!',
          confirmButtonColor: '#007500',
        });
      }
    } finally {
      setIsLogin(false);
    }
  };
  

  const handleStatusChange = async (employee, newStatus) => {
    const token = localStorage.getItem('token');
    setIsLogin(true);
  
    // Create a JSON object with only the is_active field
    const payload = {
        is_active: newStatus
    };
  
    try {
      const response = await axios.put(`${var_api}/api/package-combo/put/${employee.id}`, payload, {
        headers: {
          'Authorization': `${token}`,
          'Content-Type': 'application/json'
        }
      });
  
      if (response.status === 200) {
        Swal.fire({
          icon: 'success',
          text: 'Package Updated Successfully',
          confirmButtonColor: '#007500',
        });
        console.log('Package updated successfully!');
      }
      fetchpackageMaster();
    } catch (error) {
      console.error('Error:', error);
      if (error.response && error.response.status === 401) {
        history.push('/signin');
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error.response?.data?.error || 'Something went wrong!',
          confirmButtonColor: '#007500',
        });
      }
    } finally {
      setIsLogin(false);
    }
  };  


  const resetForm = () => {
    setPackageName('');
    setDiscount('');
    setPrice('');
    setIsDiscount(1);
    setDescription('');
    setEditMode(false); // Assuming you set profile file
};


const handleEdit = (pack) => {
    setEditMode(true);
    setpackageid(pack.id);
    setPackageName(pack.package_name);
    setDiscount(pack.discount);
    setPrice(pack.price);
    setDescription(pack.description);
    settotalAmount(pack.total_amount);
    setFinalAmount(pack.final_amount);
    setServiceCount(pack.services_count);
    setIsDiscount(pack.is_discount);
    setIsactive(pack.is_active);
  };

  const handleSearchInput = (e) => {
    setSearchQuery(e.target.value);
  };
  
  // Filter employees before applying pagination
  const filteredEmployees = Array.isArray(packageList) && packageList.filter(pack => {
    const searchLower = searchQuery.toLowerCase();
    return (
      (pack.package_name && pack.package_name.toString().toLowerCase().includes(searchLower)) ||
      (pack.description && pack.description.toString().toLowerCase().includes(searchLower)) ||
      (pack.discount && pack.discount.toString().toLowerCase().includes(searchLower)) ||
      (pack.price && pack.price.toString().toLowerCase().includes(searchLower)) ||
      (pack.services_count && pack.services_count.toString().toLowerCase().includes(searchLower)) ||
      (pack.total_amount && pack.total_amount.toString().toLowerCase().includes(searchLower)) ||
      (pack.final_amount && pack.final_amount.toString().toLowerCase().includes(searchLower)) 
    );
  });
  
  // Apply pagination to the filtered list
  const paginatedFilteredEmployees = filteredEmployees.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
  

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber); // Update current page
  };

  const handleCheckboxChange = (e) => {
    setIsDiscount(e.target.checked ? 1 : 0); // Update is_active based on checkbox status
  };


  const handlenavigate = (pack) => {
    const { id } = pack; // assuming `id` is the identifier you need
    history.push(`/package-services/${id}`);
  };



    return(
        <>
        {isLogin && <Loader />}
        <Navbar bg="light" expand="md" className="bg-body-tertiary" collapseOnSelect fixed="top">
  <Navbar.Brand href="#home">
    <img src={sage} alt="logo" className="img-fluid" style={{ maxWidth: "200px", margin: "3px 80px" }} />
  </Navbar.Brand>
  <Navbar.Toggle aria-controls="responsive-navbar-nav" />
  <Navbar.Collapse id="responsive-navbar-nav">
  <Nav className="mx-auto">
      <Nav.Link href="#" style={{ color: "black", fontSize:"25px", letterSpacing:"2px" }}>
       PACKAGE MASTER
      </Nav.Link>
    </Nav>
    <Nav className="ms-auto">
      <Nav.Link href="/sb-home" style={{ color: "black", fontSize: "15px" }}>
        <button className="btn" style={{backgroundColor:"rgb(89, 128, 71)", color:"white"}}>
          <i className="bi bi-house"></i> Go to home
        </button>
      </Nav.Link>
    </Nav>
  </Navbar.Collapse>
</Navbar>
<br/>
<br/>
<br/>
<br/>
         <div style={{margin:"auto",padding:"20px"}}>
             <Row>
             <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
             <Card style={{ border: "none", maxWidth: "28rem", padding: "15px 27px", margin: "auto", height: "auto", borderRadius: "20px", boxShadow: "rgba(0, 0, 0, 0.16) 0px 3px 6px, rgb(89, 128, 71, 0.50) 0px 3px 6px" }}>
            <Card.Body>
                <h5 style={{ textAlign: "center", color: "rgb(89, 128, 71)", fontWeight: "bold" }}>{editMode ? 'Edit Package' : 'Create Package'}</h5>
                <Form onSubmit={(e) => e.preventDefault()}>
                    <Form.Group controlId="formBasicName" className="mt-3">
                        <Form.Label>Package Name</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Enter Package Name"
                            name="title"
                            value={packageName}
                            onChange={(e) =>  setPackageName(e.target.value)}
                            required
                        />
                         {errors.packageName && <p style={{ color: 'red' }}>{errors.packageName}</p>}
                    </Form.Group>

                    <Form.Group controlId="formBasicEmail" className="mt-3">
                        <Form.Label>Description</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Enter Description"
                            name="description"
                            value={description}
                            onChange={(e) =>  setDescription(e.target.value)}
                            required
                        />
                        {errors.description && <p style={{ color: 'red' }}>{errors.description}</p>}
                    </Form.Group>

                    <Form.Group controlId="formBasicBeautician" className="mt-3 d-flex justify-content-start">
        <Form.Check
          inline
          type="checkbox"
          label="Is Discount"
          name="isBeautician"
          value="1"
          checked={is_discount === 1} 
          onChange={handleCheckboxChange}
        />
      </Form.Group>

      {is_discount === 1 ? (
        <Form.Group controlId="formBasicDiscount" className="mt-3">
          <Form.Label>Discount</Form.Label>
          <Form.Control
            type="number"
            placeholder="Enter Discount"
            name="discount"
            value={discount}
            onChange={(e) => setDiscount(e.target.value)}
            required
          />
          {errors.discount && <p style={{ color: 'red' }}>{errors.discount}</p>}
        </Form.Group>
      ) : (
        <Form.Group controlId="formBasicPrice" className="mt-3">
          <Form.Label>Price</Form.Label>
          <Form.Control
            type="number"
            placeholder="Enter Price"
            name="price"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
            required
          />
          {errors.price && <p style={{ color: 'red' }}>{errors.price}</p>}
        </Form.Group>
      )}
                     <Button variant="primary" type="button" className="mt-3" 
                      style={{ backgroundColor: "rgb(89, 128, 71)", color: "white", borderColor: "rgb(89, 128, 71)" }}
                      onClick={createPackageMaster} hidden={editMode}  // This will hide the Submit button when editMode is true
                        >
                    Submit
                    </Button>{" "}
                    <Button variant="primary" type="button" className="mt-3"
                     style={{ backgroundColor: "rgb(89, 128, 71)", color: "white", borderColor: "rgb(89, 128, 71)" }}
                     onClick={() => updatePackage()} hidden={!editMode}  // This will hide the Update button when editMode is false
                    >
                    Update
                    </Button>{" "}

                    <Button variant="danger" type="button" className="mt-3" onClick={resetForm}>
                        Reset
                    </Button>
                </Form>
            </Card.Body>
        </Card>
</Col>
                <Col xs={12} md={6} lg={6} xl={8} xxl={8} style={{padding:"0px",margin:"0px"}}>
                <Card style={{ border: "none", maxWidth:"62rem", padding:"20px", margin:"auto", height:"auto", borderRadius:"20px", fontFamily:"Arial, Helvetica, sans-serif" }}>
                 <h5 style={{color:"rgb(89, 128, 71)", fontWeight:"bold"}}>Package List  <span style={{float:"right", fontSize:"17px", color:"black", fontWeight:"bold"}}><Form.Control type="text" placeholder="Search..."  onChange={handleSearchInput}/></span> </h5>  

        <Table responsive className="mt-3">
          <thead>
            <tr>
              <th>S.No</th> 
              <th>Package Name</th>
              <th>Description</th>
              <th>Discount</th>
              <th>Price</th> 
              <th>Service Count</th>
              <th>Total Amount</th>
              <th>Final Amount</th>
              <th>Is Active</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
  {paginatedFilteredEmployees.length > 0 ? (
    paginatedFilteredEmployees.map((pack, index) => (
      <tr key={pack.id}>
        <td>{startIndex + index + 1}</td>
        <td>{pack.package_name}</td>
        <td>{pack.description}</td>
        <td>{pack.discount}</td>
        <td>{pack.price}</td>
        <td>{pack.services_count}</td>
        <td>{pack.total_amount}</td>
        <td>{pack.final_amount}</td>
        <td>
          <Form.Check
            type="switch"
            id={`custom-switch-${pack.id}`}
            label=""
            checked={pack.is_active === 1}
            onChange={(e) => handleStatusChange(pack, e.target.checked ? 1 : 0)}
          />
        </td>
        <td>
          <div className="d-flex">
            <Button variant="primary" className="m-1" onClick={() => handleEdit(pack)}>
              <i className="bi bi-pencil-square"></i>
            </Button>
            <Button variant="success" className="m-1" onClick={() => handlenavigate(pack)}>
              <i className="bi bi-arrow-right"></i>
            </Button>
          </div>
        </td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="10" className="text-center">No data available</td>
    </tr>
  )}
</tbody>
</Table>
<Pagination
  activePage={currentPage}
  itemsCountPerPage={itemsPerPage}
  totalItemsCount={filteredEmployees.length} // Update total count to reflect filtered data
  pageRangeDisplayed={5}
  onChange={handlePageChange}
  itemClass="page-item"
  linkClass="page-link"
  innerClass="pagination justify-content-end"
  activeClass="active-pagination"
/>
      </Card>
                </Col>
            </Row>
        </div>
        </>
    )
}

export default PackageMaster;